import React from "react";
import { ChangePassword } from "./ChangePassword";
import { ChangeUserName } from "./ChangeUserName";

import Grid from "@material-ui/core/Grid";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
  }),
);

export const MyProfilePage = () => {
  const classes = useStyles();

  return (
    <div>
      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <ChangeUserName />
            </Grid>
            <Grid item>
              <ChangePassword />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
